import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { AuthServiceZ } from './../authentification/auth-service.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  annonce;

  gouvernorats = [
    {
      division: 'Ariana',
      subDivisions: [
        'Ariana Medina',
        'Ettadhamen',
        ' Kalaat El Andalous',
        'Mnihla',
        'Raoued',
        'Sidi Thabet',
        'Soukra',
      ],
    },
    {
      division: 'Béja',
      subDivisions: [
        'Amdoun',
        'Beja North',
        'Beja South',
        'Goubellat',
        'Mejez El Bab',
        'Nefza',
        'Teboursouk',
        'Testour',
        'Thibar',
      ],
    },
    {
      division: 'Ben Arous',
      subDivisions: [
        'Ben Arous',
        'Boumhel',
        'El Mourouj',
        'Ezzahra',
        'Fouchana',
        'Hammam Chott',
        'Hammam-Lif',
        "M'Hamdia",
        'Medina Jedida',
        'Mégrine',
        'Mornag',
        'Rades',
        'Yasminet',
        'Azur City ',
        'Marché Gros',
        'Mghira',
        'Borj Cédria',
        'boukornine',
        'Bir El Bey',
        'Cité Olympique Rades',
        'Chouchet Rades',
        'El moujrouj 1.2.3.4.5.6',
        'Sidi Rezig',
        'Boujardga',
        'Naaseen',
        'Chbéda',
        'Khalidia',
        'Douar el Houch',
        'Mallassine',
        'Hay Hlel',
        '13 Aout',
        'El Kabaria',
        'Ibn Sina',
        'El Ouardia',
        'Jebel Jelloud',
        'la cagna (lakania)',
        'Seydi Ali Reis',
        'El Nesri',
        'Hay el baladi',
      ],
    },
    {
      division: 'Bizerte',
      subDivisions: [
        'Bizerte North',
        'Bizerte South',
        'Djoumime',
        'El Alia',
        'Ghar El Melh',
        'Ghezala',
        'Mateur',
        'Menzel Bourguiba',
        'Menzel Jemil',
        ' Ras Jebel',
        'Sejenane',
        'Tinja',
        'Utique',
        'Zarzouna',
      ],
    },
    {
      division: 'Gabès',
      subDivisions: [
        'Gabes Medina',
        'Gabes West',
        'Gabes South',
        'Ghannouch',
        'Hamma',
        'Mareth',
        'Matmata',
        'New Matmata',
        'Menzel Habib',
        'Metouia',
      ],
    },
    {
      division: 'Gafsa',
      subDivisions: [
        'Belkhir',
        'El Guetar',
        'El Ksar',
        'Gafsa Nord',
        'Gafsa Sud',
        'Mdhilla',
        'Metlaoui',
        'Oum El Araies',
        'Redeyef',
        'Sidi Aïch',
        'Sned',
      ],
    },
    {
      division: 'Jendouba',
      subDivisions: [
        'Aïn Draham',
        'Balta',
        'Bousalem',
        'Fernana',
        'Ghardimaou',
        'Jendouba',
        'Jendouba Nord',
        'Oued Mliz',
        'Tabarka',
      ],
    },
    {
      division: 'Kairouan',
      subDivisions: [
        'Alaa',
        'Bouhajla',
        'Chebika',
        'Chrarda',
        'Haffouz',
        'Hajeb El Ayoun',
        'Kairouan North',
        'Kairouan South',
        'Nasrallah',
        'Oueslatia',
        'Sbikha',
      ],
    },
    {
      division: 'Kasserine',
      subDivisions: [
        'Ayoun',
        'Ezzouhour',
        'Feriana',
        'Foussana',
        'Hassi El Ferid',
        'Hidra',
        'Jedeliane',
        'Kasserine North',
        'Kasserine South',
        'Majel Belabbes',
        'Sbeitla',
        'Sbiba',
        'Thala',
      ],
    },
    {
      division: 'Kebili',
      subDivisions: [
        'Douz North',
        'Douz South',
        'Faouar',
        'Kebili North',
        'Kebili South',
        'Souk El Ahed',
      ],
    },
    {
      division: 'Kef',
      subDivisions: [
        'Dahmani',
        'Es Sers',
        'Jerissa',
        'Kalaa Khasbat',
        'Kalaat Senane',
        'Kef East',
        'Kef West',
        'Ksour',
        'Nebeur',
        'Sakiet Sidi Youssef',
        'Tajerouine',
      ],
    },
    {
      division: 'Mahdia',
      subDivisions: [
        'Boumerdes',
        'Chebba',
        'Chorbane',
        'El Djem',
        'Hbira',
        'Ksour Essef',
        'Mahdia',
        'Melloulech',
        'Ouled Chamekh',
        'Sidi Alouane',
        'Souassi',
      ],
    },
    {
      division: 'Manouba',
      subDivisions: [
        'Borj El Amri',
        'Douar Hicher',
        'El Battan',
        'Jedaida',
        'Manouba',
        'Mornaguia',
        'Oued Ellil',
        'Tebourba',
      ],
    },
    {
      division: 'Medenine',
      subDivisions: [
        'Ben Guerdane',
        'Beni Khedache',
        'Djerba Ajim',
        'Djerba Midoun',
        'Djerba Houmt Souk',
        'Medenine North',
        'Medenine South',
        'Sidi Makhlouf',
        'Zarzis',
      ],
    },
    {
      division: 'Monastir',
      subDivisions: [
        'Bekalta',
        'Bembla',
        'Beni Hassen',
        'Jammel',
        'Ksar Hellal',
        'Ksibet El Mediouni',
        'Moknine',
        'Monastir',
        'Ouerdanine',
        'Sahline',
        'Sayada-Lamta-Bou Hjar',
        'Teboulba',
        'Zeramdine',
      ],
    },
    {
      division: 'Nabeul',
      subDivisions: [
        'Beni Khalled',
        'Beni Khiar',
        'Bou Argoub',
        'Dar Chaabane El Fehri',
        'El Mida',
        'Grombalia',
        'Hammam Ghezaz',
        'Hammamet',
        'Haouaria',
        'Kelibia',
        'Korba',
        'Menzel Bouzelfa',
        'Menzel Temime',
        'Nabeul',
        'Soliman',
        'Takelsa',
      ],
    },
    {
      division: 'Sfax',
      subDivisions: [
        'Agareb',
        'Bir Ali Ben Khelifa',
        'El Amra',
        'El Ghraiba',
        'Hencha',
        'Jebeniana',
        'Kerkennah',
        'Mahres',
        'Menzel Chaker',
        'Sakiet Eddaier',
        'Sakiet Ezzit',
        'Sfax Medina',
        'Sfax West',
        'Sfax South',
        'Skhira',
        'Thyna',
      ],
    },
    {
      division: 'Sidi Bouzid',
      subDivisions: [
        'Bir El Hfay',
        'Jelma',
        'Mazzouna',
        'Meknassi',
        'Menzel Bouzaiene',
        'Ouled Haffouz',
        'Regueb',
        'Sabalat Ouled Asker',
        'Sidi Ali Ben Aoun',
        'Sidi Bouzid East',
        'Sidi Bouzid West',
        'Souk Jedid',
      ],
    },
    {
      division: 'Siliana',
      subDivisions: [
        'Bargou',
        'Bouarada',
        'El Aroussa',
        'El Krib',
        'Gaafour',
        'Kesra',
        'Makthar',
        'Rouhia',
        'Sidi Bourouis',
        'Siliana North',
        'Siliana South',
      ],
    },
    {
      division: 'Sousse',
      subDivisions: [
        'Akouda',
        'Bouficha',
        'Enfidha',
        'Hammam Sousse',
        'Hergla',
        'Kalaa Kebira',
        'Kalaa Sghira',
        'Kondar',
        "M'Saken",
        'Sidi Bou Ali',
        'Sidi El Heni',
        'Sousse Jaouhara',
        'Sousse Medina',
        'Sousse Riadh',
        'Sousse Sidi Abdelhamid',
        'Zaouia Ksiba Thrayat',
      ],
    },
    {
      division: 'Tataouine',
      subDivisions: [
        'Bir Lahmar',
        'Dhiba',
        'Ghomrassen',
        'Remada',
        'Samar',
        'Tataouine North',
        'Tataouine South',
      ],
    },
    {
      division: 'Tozeur',
      subDivisions: ['Degueche', 'Hazoua', 'Nefta', 'Tamaghza', 'Tozeur'],
    },
    {
      division: 'Tunis',
      subDivisions: [
        'Bab Bhar',
        'Bab Souika',
        'Bardo',
        'Bouhaira',
        'Carthage',
        'El Khadra',
        'El Menzah',
        // 'El Ouardia',
        'El Tahrir',
        'Ezzouhour',
        'Hrairia',
        // 'Jebel Jelloud',
        // 'Kabaria',
        'La Goulette',
        'La Marsa',
        'Le Kram',
        'Medina',
        'Omrane',
        'Omrane Superieur',
        'Sidi El Bechir',
        'Sidi Hassine',
        'Sijoumi',
      ],
    },
    {
      division: 'Zaghouan',
      subDivisions: [
        'Bir Mchergua',
        'Fahs',
        'Nadhour',
        'Saouaf',
        'Zaghouan',
        'Zriba',
      ],
    },
    // {
    //   division: 'JUMIA',
    //   subDivisions: [],
    // },
  ];
  regions = [
    {
      name: 'Sud',
      divisions: [
        'Tataouine',
        'Medenine',
        'Tozeur',
        'Kebili',
        'Gabès',
        'Gafsa',
      ],
      delay: 48,
    },
    {
      name: 'Grand Tunis',
      divisions: ['Tunis', 'Ben Arous', 'Manouba'],
      delay: 24,
    },
  ];
  AdminPermissions = {
    //    1: this.translate.get('SIDENAV.CONCIERGERIE').toPromise(),
    1: 'Conciergerie',
    2: 'Pickup et livraison',
    5: 'Users only',
    6: 'Finance only',
    7: 'App versioning',
    8: 'Analytics',
    9: 'Finance & Reporting',
    10: 'Angel eyes',
    11: 'Can edit',
    12: 'superAdmin',
    13: 'Runsheets',
    14: 'Edit runsheet-transfer',
    17: 'Receive emails',
    20: 'Changement de prix',
  };
  pickUpStatusList = [
    {
      name: "En attente d'enlévement",
      active: false,
      value: 1,
    },
    {
      name: 'Assigné',
      active: false,
      value: 2,
    },
    {
      name: 'Accepted',
      active: false,
      value: 3,
    },
    {
      name: 'Pickup assurée',
      active: false,
      value: 10,
    },
    {
      name: 'Refusé par chauffeur',
      active: false,
      value: 4,
    },
    {
      name: 'Commencé',
      active: false,
      value: 5,
    },
    {
      name: 'Entrée au centrale',
      active: false,
      value: 6,
    },
    {
      name: 'Annulée par chauffeur aprés acceptation',
      active: false,
      value: 7,
    },
    {
      name: 'Annulée par admin',
      active: false,
      value: 8,
    },
    {
      name: 'Annulée par vendeur',
      active: false,
      value: 14,
    },
    {
      name: 'Retour définitif',
      active: false,
      value: 16,
    },
    {
      name: 'Retour vendeur',
      active: false,
      value: 17,
    },
  ];
  deliveryStatusList = [
    {
      name: 'En attente de livraison',
      active: false,
      value: 1,
    },
    {
      name: 'Assigné',
      active: false,
      value: 2,
    },
    {
      name: 'Livraison en cours',
      active: false,
      value: 10,
    },
    {
      name: 'Refusé par chauffeur',
      active: false,
      value: 4,
    },
    {
      name: 'Commencée',
      active: false,
      value: 5,
    },

    {
      name: 'Point Relais',
      active: false,
      value: 18,
    },
    {
      name: 'Commande livrée',
      active: false,
      value: 6,
    },
    {
      name: 'declined by admin',
      active: false,
      value: 8,
    },
    {
      name: 'Annulée par vendeur',
      active: false,
      value: 14,
    },
    {
      name: 'Retour depuis point relais',
      active: false,
      value: 19,
    },
    {
      name: 'Retour provisoir',
      active: false,
      value: 15,
    },
    {
      name: 'Retour définitif',
      active: false,
      value: 16,
    },
    {
      name: 'Retour vendeur',
      active: false,
      value: 17,
    },
    {
      name: 'Adresse non exacte',
      active: false,
      value: 12,
    },
  ];
  TransferStatus = {
    1: 'En cours',
    2: 'En route',
    3: 'Arrivé',
  };
  user;
  itemsPerPage = 25;

  constructor(
    private httpClient: HttpClient,
    private authServiceZ: AuthServiceZ,
    private translate: TranslateService
  ) {
    this.getMyProfileNow();

    if (localStorage.getItem('itemsPerPage')) {
      this.itemsPerPage = parseInt(localStorage.getItem('itemsPerPage'));
    }
  }

  hideAnnonce(): void {
    localStorage.removeItem('annonce');
  }
  getMyPointRelais(query): any {
    return this.httpClient
      .get(
        environment.api.serverUrl +
          '/pointRelais' +
          '?sort=-createdAt' +
          '&query=' +
          query
      )
      .toPromise();
  }

  getRegions(): Promise<any> {
    return this.httpClient
      .get(environment.api.backendBase + `/regions`)
      .toPromise();
  }

  deletePointRelais(id): any {
    return this.httpClient
      .delete(environment.api.serverUrl + '/pointRelais/' + id)
      .toPromise();
  }

  addPointRelais(body): any {
    return this.httpClient
      .post(environment.api.serverUrl + '/pointRelais', body)
      .toPromise();
  }

  updatePointRelais(id, body): any {
    return this.httpClient
      .post(environment.api.serverUrl + '/pointRelais/' + id, body)
      .toPromise();
  }

  updateApiKey(id): any {
    return this.httpClient
      .post(environment.api.business + '/updateapikey', { id })
      .toPromise();
  }

  updateNumberOfItemPerPage(itemsPerPage = '') {
    localStorage.setItem(
      'itemsPerPage',
      itemsPerPage ? itemsPerPage : this.itemsPerPage + ''
    );
  }

  getMySubGroup(): any {
    return this.httpClient
      .get(environment.api.group + '/subGroups')
      .toPromise()
      .catch(this.handleError);
  }

  getMyProfile(id): any {
    return this.httpClient
      .get(
        environment.api.user +
          '/admins/' +
          this.authServiceZ.credentials.user._id
      )
      .toPromise()
      .catch(this.handleError);
  }

  getMyProfileNow(): any {
    if (this.authServiceZ.credentials?.user) {
      return this.httpClient
        .get(
          environment.api.user +
            '/admins/' +
            this.authServiceZ.credentials.user._id
        )
        .toPromise()
        .then((d) => {
          this.user = d;

          if (d['regions'] && d['regions'].length > 1) {
            this.gouvernorats = d['regions'];
          }
        });
    }
  }

  updateProfileUser(user): any {
    return this.httpClient
      .put(environment.api.user + '/users/' + user._id, user)
      .toPromise()
      .catch(this.handleError);
  }

  getBusinessByUserId(user): any {
    return this.httpClient
      .get(environment.api.user + '/business/users')
      .toPromise();
  }

  updateProfileAdmin(id, user): any {
    return this.httpClient
      .put(environment.api.user + '/admins/' + id, user)
      .toPromise()
      .catch(this.handleError);
  }

  addGroup(group): any {
    return this.httpClient
      .post(environment.api.group, group)
      .toPromise()
      .catch(this.handleError);
  }

  getBusiness(business): any {
    return this.httpClient
      .get(environment.api.business + '/' + business)
      .toPromise()
      .catch(this.handleError);
  }

  getDeliveries(queries): any {
    const params = new HttpParams({
      fromObject: queries,
    });

    return this.httpClient
      .get(environment.api.backendBase + '/deliveryrequests', { params })
      .toPromise()
      .catch(this.handleError);
  }

  updateBusiness(business): any {
    return this.httpClient
      .put(environment.api.business + '/' + business._id, business)
      .toPromise()
      .catch(this.handleError);
  }

  addBusiness(business): any {
    return this.httpClient
      .post(environment.api.business, business)
      .toPromise()
      .catch(this.handleError);
  }

  updatejobDropOffPosition(id, body): any {
    return this.httpClient
      .put(environment.api.deliveryRequest + '/updateDropOff/' + id, body)
      .toPromise();
  }

  updateDropOffAddress(id, body): any {
    return this.httpClient
      .post(
        environment.api.deliveryRequest + '/updatedropoffaddress/' + id,
        body
      )
      .toPromise();
  }

  updatePickUpAddress(id, body): any {
    return this.httpClient
      .post(
        environment.api.deliveryRequest + '/updatepickupaddress/' + id,
        body
      )
      .toPromise();
  }

  editGroup(group): any {
    return this.httpClient
      .put(environment.api.group + '/' + group._id, group)
      .toPromise()
      .catch(this.handleError);
  }

  getAllPermissions(): any {
    return this.httpClient
      .get(environment.api.permission)
      .toPromise()
      .catch(this.handleError);
  }

  getDriverPositionForAspeceficConciergerie(query) {
    return this.httpClient
      .get(
        environment.api.jobPositions +
          '?sort=-createdAt&query=' +
          JSON.stringify(query)
      )
      .toPromise()
      .catch(this.handleError);
  }

  getJourneyById(query): any {
    const populate = [{ path: 'jobRequests', populate: [{ path: 'dropOff' }] }];

    return this.httpClient
      .post(environment.api.serverUrl + '/lastPosition/driverJourney', query)
      .toPromise()
      .catch(this.handleError);
  }

  getDeliveryRequest(id) {
    const query = {
      _id: id,
    };
    const populate = [
      { path: 'business' },
      { path: 'createdBy' },
      { path: 'pickUp' },
      { path: 'dropOff' },
      { path: 'driver' },
    ];

    return this.httpClient
      .get(
        environment.api.deliveryRequest +
          '?sort=-createdAt&query=' +
          JSON.stringify(query) +
          '&populate=' +
          JSON.stringify(populate)
      )
      .toPromise()
      .catch(this.handleError);
  }

  generateMultipleBorderaux(query): any {
    return this.httpClient
      .post(environment.api.backendBase + '/jobrequests/bordereau', query, {
        observe: 'response',
        responseType: 'arraybuffer',
      })
      .toPromise();
  }

  generateMultipleEchangedBorderaux(query): any {
    return this.httpClient
      .post(
        environment.api.backendBase + '/jobrequests/bordereau/exchanged',
        query,
        {
          observe: 'response',
          responseType: 'arraybuffer',
        }
      )
      .toPromise();
  }

  generateExcel(query): any {
    return this.httpClient
      .post(environment.api.deliveryRequest + '/partner/filterStatus', query, {
        observe: 'response',
        responseType: 'arraybuffer',
      })
      .toPromise();
  }

  getAllAppVersions(): any {
    return this.httpClient
      .get(environment.api.mobileApp + '/newVersion')
      .toPromise();
  }

  getAllSMStext(): any {
    return this.httpClient
      .get(environment.api.serverUrl + '/smsText/')
      .toPromise();
  }
  editSMStext(body): any {
    return this.httpClient
      .put(environment.api.serverUrl + '/smsText/' + body._id, body)
      .toPromise();
  }
  deleteSMStext(id): any {
    return this.httpClient
      .delete(environment.api.serverUrl + '/smsText/' + id)
      .toPromise();
  }
  addSMStext(body): any {
    return this.httpClient
      .post(environment.api.serverUrl + '/smsText/', body)
      .toPromise();
  }

  updateAppVersions(query): any {
    return this.httpClient
      .put(environment.api.mobileApp + '/newVersion', query)
      .toPromise();
  }

  getDataForFinalClient(query): any {
    return this.httpClient
      .post(environment.api.packingSlip + '/finalClient', query)
      .toPromise();
  }

  downLoadFile(data: any, type: string, fileName) {
    const blob = new Blob([data], { type });
    const url = window.URL.createObjectURL(blob);
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.setAttribute(
      'download',
      fileName?.trim() ?? `${new Date(Date.now()).toDateString()}.xlsx`
    );
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  parseCurrencyAmountsForCharts(currencyfloat, cb) {
    if (currencyfloat / 1000000000 > 1) {
      return `${
        cb ? cb(currencyfloat / 1000000000) : currencyfloat / 1000000000
      }B`;
    }
    if (currencyfloat / 1000000 > 1) {
      return `${cb ? cb(currencyfloat / 1000000) : currencyfloat / 1000000}M`;
    }
    if (currencyfloat / 1000 > 1) {
      return `${cb ? cb(currencyfloat / 1000) : currencyfloat / 1000}K`;
    }

    return currencyfloat;
  }

  getFileNameFromHeader(header) {
    let filename = '';
    const disposition = header;
    if (disposition && disposition.indexOf('attachment') !== -1) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '');
      }
    }
    return filename;
  }

  timeDiffCalc(dateFuture) {
    const dateNow = new Date();
    dateFuture = new Date(dateFuture);

    let diffInMilliSeconds =
      Math.abs(dateNow.getTime() - dateFuture.getTime()) / 1000;

    // calculate days
    const days = Math.floor(diffInMilliSeconds / 86400);
    diffInMilliSeconds -= days * 86400;

    // calculate hours
    const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
    diffInMilliSeconds -= hours * 3600;

    // calculate minutes
    const minutes = Math.floor(diffInMilliSeconds / 60) % 60;
    diffInMilliSeconds -= minutes * 60;

    let difference = '';
    if (days > 0) {
      difference += days === 1 ? `${days} day, ` : `${days} days, `;
    }
    if (hours > 0) {
      difference +=
        hours === 0 || hours === 1 ? `${hours} hour, ` : `${hours} hours, `;
    }

    difference +=
      minutes === 0 || hours === 1
        ? `${minutes} minutes`
        : `${minutes} minutes`;

    return {
      days,
      hours,
      minutes,
      differenceStr: difference,
    };
  }

  // Address hierarchy methods
  getCities(): any {
    return this.httpClient
      .get(environment.api.backendBase + '/addresses/cities')
      .toPromise()
      .catch(this.handleError);
  }

  getDistricts(cityId: string): any {
    return this.httpClient
      .get(environment.api.backendBase + `/addresses/districts/${cityId}`)
      .toPromise()
      .catch(this.handleError);
  }

  getNeighborhoods(cityId: string, districtId?: string): any {
    let url = environment.api.backendBase + `/addresses/neighborhoods/${cityId}`;
    if (districtId) {
      url += `?districtId=${districtId}`;
    }
    return this.httpClient
      .get(url)
      .toPromise()
      .catch(this.handleError);
  }

  searchAddresses(cityId: string, term: string): any {
    return this.httpClient
      .get(environment.api.backendBase + `/addresses/search?cityId=${cityId}&term=${term}`)
      .toPromise()
      .catch(this.handleError);
  }

  private;

  handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response || error) {
      const body = error.json() || '';
      const err = JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Promise.reject(errMsg);
  }
}
